import React, { useState } from "react";
import PropTypes from "prop-types";
import { GNOMAD_POPULATIONS } from "../../../../../../../common/helpers/Constant";
import { getRowData } from "./getRowData";
import { getPopulationMainRowData, renderColumn } from "./helpers";

const PopulationsFrequenciesBody = ({ item, isMito }) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const handleRowClick = (id) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.includes(id)
        ? prevExpandedRows.filter((rowId) => rowId !== id)
        : [...prevExpandedRows, id]
    );
  };

  const populationsRows = GNOMAD_POPULATIONS.map((population, index) => {
    const { suffix, name } = population;
    const {
      alleleCount,
      alleleNumber,
      heteroplasmic,
      homoplasmicOrHomozygotes,
      hemizygotes,
      alleleFrequency,
    } = getPopulationMainRowData(item, suffix, isMito);
    if (alleleNumber === null) return null;

    const rowItems = [];
    for (const [key, value] of Object.entries(item)) {
      if (key.includes(suffix)) {
        rowItems[key] = value;
      }
    }
    const row = getRowData(rowItems, index, suffix, item?.nonpar);

    return (
      <tbody key={`tbody_${suffix}_${index}`}>
        <tr key={`tr_${suffix}_${index}`}>
          <td className="tw-w-17/100 tw-text-right">
            {row ? (
              <>
                {`${name} `}
                <a onClick={() => handleRowClick(name)}>
                  <i
                    className={`varsome-icons iconcaret-${
                      expandedRows.includes(name) ? "down" : "right"
                    }`}
                  />
                </a>
              </>
            ) : (
              name
            )}
          </td>
          {renderColumn("empty-column", "", "tw-w-13/100")}
          {renderColumn("ac", alleleCount, "tw-w-12/100 tw-text-right")}
          {renderColumn("an", alleleNumber, "tw-w-13/100 tw-text-right")}
          {isMito &&
            renderColumn("het", heteroplasmic, "tw-w-12/100 tw-text-right")}
          {renderColumn(
            "hom",
            homoplasmicOrHomozygotes,
            "tw-w-12/100 tw-text-right"
          )}
          {item?.nonpar === 1 &&
            renderColumn("hem", hemizygotes, "tw-w-12/100 tw-text-right")}
          <td className="gnomad-af-td-padding tw-w-21/100">
            {alleleFrequency || "-"}
          </td>
        </tr>
        {expandedRows.includes(name) && row}
      </tbody>
    );
  });

  return populationsRows;
};

PopulationsFrequenciesBody.propTypes = {
  item: PropTypes.shape({
    nonpar: PropTypes.number,
    an_female: PropTypes.number,
    an_male: PropTypes.number,
    ac: PropTypes.number,
    af: PropTypes.number,
    an: PropTypes.number,
    ac_hom: PropTypes.number,
    ac_het: PropTypes.number,
    nhomalt: PropTypes.number,
  }),
  isMito: PropTypes.bool,
};

PopulationsFrequenciesBody.defaultProps = {
  item: {},
  isMito: false,
};
export default PopulationsFrequenciesBody;
